import React from 'react';

export const EmptyAttempts = () => <>&mdash;</>;
